import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SaveFilledIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 3h10.17a2 2 0 0 1 1.42.59l3.82 3.82a2 2 0 0 1 .59 1.42V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm3.25 2.5a.75.75 0 0 0-.75.75v2c0 .414.336.75.75.75h5.5a.75.75 0 0 0 .75-.75v-2a.75.75 0 0 0-.75-.75h-5.5ZM12 12.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SaveFilledIcon.displayName = 'SaveFilledIcon';
